import React from 'react';
import { Text, Icon, Flex } from 'core/components';

import ResultMenuItem from './ResultMenuItem';

function Interface({ item, selected, query, IconCmp, onItemClick, ...rest }) {
  const { id, path, interface_description, device_name, snmp_alias } = item;
  return (
    <ResultMenuItem
      {...rest}
      selected={selected}
      onClick={() => onItemClick({ type: 'interface', id, path }, 'Search Results')}
    >
      <Flex gridArea="icon" alignItems="center" justifyContent="center">
        <IconCmp iconSize={22} />
      </Flex>

      <Flex gridArea="title" gap={1}>
        <Text className="title">{interface_description}</Text>
        <Text className="title" muted>
          {device_name}
        </Text>
      </Flex>

      <Flex gridArea="rightIcon" alignItems="center" justifyContent="center">
        <Icon icon={selected ? 'key-enter' : undefined} color="#ffffff" />
      </Flex>

      <Text
        className="description"
        gridArea="description"
        muted
        small
        whiteSpace="nowrap"
        textOverflow="ellipsis"
        style={{ overflow: 'hidden' }}
      >
        {snmp_alias}
      </Text>
    </ResultMenuItem>
  );
}

export default Interface;
